import * as React from "react"
import colors from "theme/colors"

const SvgComponent = ({
  color = colors.coffeeBrown,
  ...props
}: React.SVGProps<SVGSVGElement>) => {
  const w = 61
  const h = 50
  return (
    <svg
      viewBox={`0 0 ${w} ${h}`}
      width={w}
      height={h}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_b_3751_71854)">
        <rect
          x="0.5"
          width="60"
          height="50"
          rx="25"
          fill="black"
          fillOpacity="0.2"
        />
        <path
          d="M26.5 20.5L22 25L26.5 29.5"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M34.5 29.5L39 25L34.5 20.5"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="square"
        />
        <rect
          x="1.5"
          y="1"
          width="58"
          height="48"
          rx="24"
          stroke="white"
          strokeWidth="2"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_3751_71854"
          x="-10.5"
          y="-11"
          width="82"
          height="72"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="5.5" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_3751_71854"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_3751_71854"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default SvgComponent
